import { render } from "./DeleteDnsServer.vue?vue&type=template&id=27e007be&scoped=true"
import script from "./DeleteDnsServer.vue?vue&type=script&lang=js"
export * from "./DeleteDnsServer.vue?vue&type=script&lang=js"

import "./DeleteDnsServer.vue?vue&type=style&index=0&id=27e007be&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e007be"]])

export default __exports__